module.exports = {
    // API_URL : "https://9fa8-2401-4900-1f39-3e78-84f9-be15-1810-89c6.in.ngrok.io/api",
    API_URL : "https://d3d7cdbpcxi24d.cloudfront.net/api",
    // API_URL : "http://localhost:5001/api",
    PRODUCT_S3 : "https://capno-product-image.s3.amazonaws.com",

}